import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import * as sharedComponents from './components';
import * as sharedDirectives from './directives';
import * as sharedPipes from './pipes';
import { NgxMaskModule } from 'ngx-mask';

const modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  NgxMaskModule.forRoot(),
];
const declarables = [sharedComponents.components, sharedDirectives.directives, sharedPipes.pipes];

export const shared = {
  declarables,
  modules,
};
@NgModule({
  declarations: shared.declarables,
  imports: shared.modules,
  exports: shared.declarables,
})
export class SharedModule {}
